/* eslint-disable max-len */
/* eslint-disable security/detect-object-injection */

import React, { useState,memo, useRef } from 'react';
import DateRange from '../../../../components/TopBar/DateRange';
import { useOnClickOutside } from '../../../../CommonMethods/OutsideClick';
import { DatePicker } from 'antd'
import moment from 'moment';
import dayjs from 'dayjs'

const Filter = ({
    FilterData,
    dateRangeFilterName,FilterCheckbox, 
    handleApplyFilter, selectedName,
    setIsFilterOpen,handleSelectObject,
    selectedFilter, setSelectedFilter,
    tooltip,  filterCount, setFilterCheckBox,
    currentFinacialYear,academicYears,
    setSelectedName,searchParams,
    setSearchParams,finacialYear,ref}) => {

    const [selectedDates, setSelectedDates] = useState({})

    const closeRef = useRef();
    /* The `useOnClickOutside` hook is a custom hook that is used to detect clicks outside of a specified
    element. In this case, it is used to detect clicks outside of the filter component. */
    useOnClickOutside(closeRef, () => {
        setIsFilterOpen(false)
    })

    /**
     * The function disables future dates by comparing the current date with the end of the current
     * day.
     * @returns a boolean value. It checks if the "current" date is after the current date and returns
     * true if it is, indicating that the date is disabled. Otherwise, it returns false, indicating
     * that the date is not disabled.
     */
    const disabledFutureDate = (current) => {
        // Disable dates that are after the current date
        return current && current > moment().endOf('day');
    };

    return (
        <div class={`filter_btn_drp_dwn top2 shadow-s1 ${filterCount ===0 ? '' : 'filterCnt'} filter_modal`} ref={closeRef}>
            <div class="flex h-[80%]">
                <ul class="flex list-none flex-col flex-wrap filter_btn_drp_dwn_div1" role="tablist" data-te-nav-ref="">
                    {Object.keys(FilterData).map((item, index) => (
                        <li role="presentation" class="flex-grow text-center" key={item}>
                            <button id={item} data-test-id={index+item}
                                onClick={() => {
                                    setSelectedFilter(item); 
                                }}  
                                class={`${dateRangeFilterName !== undefined ? "min-w-[125px] text-start text-sm font-normal" : "text-start relative block text-sm font-normal "} ${selectedFilter === item ? " text-[#106EB4]" : "text-[#4D555B]"}`}>{dateRangeFilterName === undefined ? item.replace(/_/g, ' ').toLowerCase().replace(/(?:^|\s)\S/g, function(c) { return c.toUpperCase(); }) : dateRangeFilterName}</button>
                        </li>))}
                </ul>
                <div class={selectedFilter !== "date_range" ? "filter_btn_drp_dwn_div2" : "border-l border-[#E6E8EA] h-[50px] filter_btn_drp_dwn_div2"}>
                    <div class="hidden transition-opacity duration-150 ease-linear data-[te-tab-active]:block opacity-100" id="tabs-home03" role="tabpanel" aria-labelledby="tabs-home-tab03" data-te-tab-active="">
                        <div class="overflow-auto overflow-x-hidden scroll-smooth scroll-bar">
                            <div class={"w-full"}>
                                {<div className='-mt-1'>
                                    <div class="relative w-full">
                                        <DatePicker
                                            className='cursor-pointer custom-datepicker slct-inpt-fld mt-1'
                                            id='report_date'
                                            format="MMM DD, YYYY" 
                                            placeholder='Select Date'
                                            onChange={(date,dateString,id) => {
                                                handleSelectObject('report_date',dateString,); 
                                                setSelectedDates((prv)=>({
                                                    ...prv,
                                                    ["report_date"]:  date
                                                }))
                                            }} 
                                            value={searchParams.get('report_date') !== null ? dayjs(FilterCheckbox?.report_date) :  searchParams.get('report_date') === null ? selectedDates?.report_date === '' ?  ''  : selectedDates?.report_date : selectedDates?.report_date === '' ?  ''  : selectedDates?.report_date }
                                            allowClear={false}  
                                            defaultValue={null}
                                            suffixIcon={<img src="/images/calendar.svg" alt="icon" className="cursor-pointer absolute top-[50%] -translate-y-[50%] right-[-20px] w-[20px]"/>}
                                        />
                                    </div>
                                </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="flex items-center justify-center pt-[10px] mt-1 shadow-top">
                <button type="button"  onClick={()=>{
                    handleApplyFilter(false); 
                    setIsFilterOpen(false)}} class="clr-btn">Clear All
                </button>
                <button type="button" onClick={()=>{
                    handleApplyFilter(true); 
                    setIsFilterOpen(false)}}   id = "apply_filter"  class="aply-fltr-btn">Apply Filter(s)
                </button>
            </div>
        </div> 
    );
}

export default memo(Filter);
